import { SignIn } from '@clerk/react'
import { AuthLayout } from '../../ui/AuthLayout.js'

/**
 * Signing in, which this product no longer does itself.
 *
 * There is no form here and no password in this codebase. The identity
 * provider's component owns the whole exchange — the password, the second
 * factor, the lock-out, the reset link, Google — and this file owns where it
 * sits and what is beside it (ADR 0004).
 *
 * `routing="path"` rather than the default hash, so the provider's own steps
 * are real addresses under `/signin` and the browser's back button works
 * through them. The route is mounted as a wildcard for the same reason.
 */
export function SignInPage() {
  return (
    <AuthLayout>
      <SignIn
        routing="path"
        path="/signin"
        signUpUrl="/signup"
        // Where somebody lands once the provider is satisfied. Not the
        // dashboard: a new identity has no organisation yet, and the app
        // decides between the product and the organisation form from the
        // session it reads at `/`.
        fallbackRedirectUrl="/"
        appearance={{ elements: { rootBox: 'w-full', cardBox: 'w-full shadow-none' } }}
      />
    </AuthLayout>
  )
}
